var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isReady && !_vm.isEditor)?_c('player',{class:_vm.site == '' ? 'wave-layout' : '',attrs:{"id":"#app","dirs":_vm.dirList}}):(_vm.isReady)?_c('editor',{attrs:{"id":"#app","dirs":_vm.dirList,"stateid":_vm.stateid}}):_c('div',[_c('div',{staticClass:"loading-bar"}),_vm._v(" "),_c('button',{staticStyle:{"display":"none"},attrs:{"id":"app_load_check_button"},on:{"click":_vm.updateLoad}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7a2c8d93","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 651
// module chunks = 0